export interface EventProps {
  win?: Window;
  path?: string;
  title?: string;
  event?: string;
}

export class GoogleAnalytics {
  static getWindow = (win?: Window): Window | undefined => {
    return win || window;
  };
  static getHost = (window?: Window): string | undefined => {
    return GoogleAnalytics.getWindow(window)?.location?.host;
  };
  static getPath = (window?: Window): string | undefined => {
    return GoogleAnalytics.getWindow(window)?.location?.pathname;
  };
  static getTitle = (window?: Window): string | undefined => {
    return GoogleAnalytics.getWindow(window)?.document?.title;
  };

  // can be called with
  //  no params - the current host, path (set by React routing), page title (set by React screen)
  //  sending win - allows explicitly setting window for use within NextJS app
  //  path - to override the actual window path
  //  title - to override the actual window page title
  //  event - to override the default event type
  static pushEvent = ({ win, path, title, event }: EventProps = {}): void => {
    const theWindow = GoogleAnalytics.getWindow(win);
    if (theWindow) {
      const eventType = event || "page.event";
      // NOTE: window.dataLayer will be set by globally injected google analytics
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (theWindow.dataLayer = theWindow.dataLayer || []).push({
        event: eventType,
        eventType: {
          host: GoogleAnalytics.getHost(theWindow),
          pageUrl: path || GoogleAnalytics.getPath(theWindow), // Page URL without host & params
          pageTitle: title || GoogleAnalytics.getTitle(theWindow), // Title
        },
      });
    }
  };
}
